import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";

class PerformancePackageStore {

  @observable performance_guarantees = [];
  @observable dispensing_fee = [];
  @observable rebate_review = [];
  @observable awp_mismatch = [];
  @observable specialty_performance = [];
  @observable claim_cost_summary = [];
  @observable other_exclusion = [];
  @observable exclusion_review = [];
  @observable total_exclusion = {};
  @observable effective_discount = [];
  @observable specialty_discount = [];
  @observable specialty_brand_discount = [];
  @observable specialty_generic_discount = [];
  @observable ranges = [{range: "0 to 50", total_count:0, total_awp:0, total_cost: 0}, {range: "50.01 to 100", total_count:0, total_awp:0, total_cost: 0}, {range: "100.01 to 250", total_count:0, total_awp:0, total_cost: 0},
  {range: "250.01 to 500", total_count:0, total_awp:0, total_cost: 0}, {range: "500.01 to 1000", total_count:0, total_awp:0, total_cost: 0}, {range: ">1000", total_count:0, total_awp:0, total_cost: 0}]

  @observable action = false;
  @observable errors = {};
  @observable url = "/api/v1/performancePackageActions";

  @action setErrors = () => {
    this.errors = {};
  };
  @action setAction = action => {
    this.action = action;
  };

  
  @action getClaimCostSummary = async data => {
    this.claim_cost_summary = [];
    try {
      let response = await post(
        `${this.url}/getClaimCostSummary`,
        data
      );
      this.claim_cost_summary = response.data;
      response.data.length && response.data.map(item => {
        if(item.cost_summary <= 50) {
           this.ranges[0].total_count+=item.claim_count;
           this.ranges[0].total_awp+=Number(item.total_awp);
           this.ranges[0].total_cost+=Number(item.total_ingredient_cost);
  
        }
        else if(item.cost_summary <= 100) {
          this.ranges[1].total_count+=item.claim_count;
          this.ranges[1].total_awp+=Number(item.total_awp);
           this.ranges[1].total_cost+=Number(item.total_ingredient_cost);
        }
        else if(item.cost_summary <= 250) {
            this.ranges[2].total_count+=item.claim_count;
            this.ranges[2].total_awp+=Number(item.total_awp);
           this.ranges[2].total_cost+=Number(item.total_ingredient_cost);
        }
        else if(item.cost_summary <= 500) {
            this.ranges[3].total_count+=item.claim_count;
            this.ranges[3].total_awp+=Number(item.total_awp);
           this.ranges[3].total_cost+=Number(item.total_ingredient_cost);
        }
        else if(item.cost_summary <= 1000) {
          this.ranges[4].total_count+=item.claim_count;
          this.ranges[4].total_awp+=Number(item.total_awp);
           this.ranges[4].total_cost+=Number(item.total_ingredient_cost);
        }
        else if(item.cost_summary > 1000) {
            this.ranges[5].total_count+=item.claim_count;
            this.ranges[5].total_awp+=Number(item.total_awp);
           this.ranges[5].total_cost+=Number(item.total_ingredient_cost);
        }
      })
    } catch (err) {
      console.log(err);
    }
  };

  @action getOtherExclusion = async data => {
    this.other_exclusion = [];
    try {
      let response = await post(
        `${this.url}/getOtherExclusion`,
        data
      );
      this.other_exclusion = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getPerformanceGuarantees = async data => {
    this.performance_guarantees = [];
    try {
      let response = await post(
        `${this.url}/getPerformanceGuarantees`,
        data
      );
      this.performance_guarantees = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  
  @action getSpecialtyPerformance = async data => {
    this.specialty_performance = [];
    try {
      let response = await post(
        `${this.url}/getSpecialtyPerformance`,
        data
      );
      this.specialty_performance = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getDispensingFees = async data => {
    this.dispensing_fee = [];
    try {
      let response = await post(
        `${this.url}/getDispensingFees`,
        data
      );
      this.dispensing_fee = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getRebateReview = async data => {
    this.rebate_review = [];
    try {
      let response = await post(
        `${this.url}/getRebateReview`,
        data
      );
      this.rebate_review = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getAWPMismatch = async data => {
    this.awp_mismatch = [];
    try {
      let response = await post(
        `${this.url}/getAWPMismatch`,
        data
      );
      this.awp_mismatch = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getExclusionReview = async data => {
    this.exclusion_review = [];
    try {
      let response = await post(
        `${this.url}/getExclusionReview`,
        data
      );
      this.exclusion_review = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalExclusion = async data => {
    this.total_exclusion = {};
    try {
      let response = await post(
        `${this.url}/getTotalExclusion`,
        data
      );
      this.total_exclusion = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  
  @action getEffectiveDiscount = async data => {
    this.effective_discount = [];
    try {
      let response = await post(
        `${this.url}/getEffectiveDiscount`,
        data
      );
      this.effective_discount = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getSpecialtyDiscount = async data => {
    this.specialty_discount = [];
    try {
      let response = await post(
        `${this.url}/getSpecialtyDiscount`,
        data
      );
      this.specialty_discount = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getSpecialtyBrandDiscount = async data => {
    this.specialty_brand_discount = [];
    try {
      let response = await post(
        `${this.url}/getSpecialtyBrandDiscount`,
        data
      );
      this.specialty_brand_discount = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getSpecialtyGenericDiscount = async data => {
    this.specialty_generic_discount = [];
    try {
      let response = await post(
        `${this.url}/getSpecialtyGenericDiscount`,
        data
      );
      this.specialty_generic_discount = response.data;
    } catch (err) {
      console.log(err);
    }
  };


}

export default PerformancePackageStore;
